import ApproveSalaryDetailTemplate from './components/ApproveDetailTemplate';

export type KTApproveParamsForm = {
  codeDetail: string;
  bankId?: OptionType,
  dateTransfer: string,
  methodTransfer?: OptionType,
  description: string;
};

const ApproveSalaryHistoryDetail: React.FC<ActiveRoles> = ({
  roleCreate, roleIndex, roleOther, roleUpdate, roleView
}) => (
  <ApproveSalaryDetailTemplate
    roleCreate={roleCreate}
    roleIndex={roleIndex}
    roleOther={roleOther}
    roleUpdate={roleUpdate}
    roleView={roleView}
    isHistory
  />
);

export default ApproveSalaryHistoryDetail;
